import styled from 'styled-components'

export const UserDropdown = styled.div`
  position: absolute;
  top: 64px;
  right: 12px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 8px;
  min-width: 200px;
  z-index: 1000;
  animation: dropdownFadeIn 0.2s ease-out forwards;
  transform-origin: top right;

  @keyframes dropdownFadeIn {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    right: 16px;
    top: 56px;
  }
`

export const UserDropdownItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #1a1a1a;
  transition: all 0.2s ease;
  text-align: left;
  font-family: inherit;

  &:hover {
    background: #f8f8f8;
  }

  &:active {
    background: #f0f0f0;
  }

  svg {
    color: #6b6b6b;
    transition: color 0.2s ease;
  }

  &:hover svg {
    color: #1a1a1a;
  }

  span {
    flex: 1;
  }
`

export const UserDropdownDivider = styled.div`
  height: 1px;
  background: #e5e5e5;
  margin: 8px 0;
`

export const ThemeToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`

export const LanguageSection = styled.div`
  padding: 8px 16px;
`

export const LanguageLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #6b6b6b;
  margin-bottom: 8px;
`

export const LanguageFlags = styled.div`
  display: flex;
  gap: 8px;
`

export const FlagButton = styled.button<{ $active?: boolean }>`
  width: 36px;
  height: 28px;
  border: 1px solid ${({ $active }) => ($active ? '#2563eb' : '#e5e5e5')};
  border-radius: 4px;
  background: ${({ $active }) => ($active ? '#eff6ff' : 'transparent')};
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    border-color: #2563eb;
    background: #f8faff;
  }
`
